export const environment = {
  production: true,

  pwaFirebaseConfig: '{"apiKey":"AIzaSyD3mmElMLy0whvxpIC7VhCX4NXw4lg0tcM","authDomain":"tu-dortmund-app.firebaseapp.com","databaseURL":"https://tu-dortmund-app.firebaseio.com","projectId":"tu-dortmund-app","storageBucket":"tu-dortmund-app.appspot.com","messagingSenderId":"930124740579","appId":"1:930124740579:web:7a12ded66d9bd3338d52d6"}',
  pwaFirebaseKey: "BMDXAJYLYUZvxdeatQq2QBsxgDE1ma9PyC50JAj6J8ji_1pZ1XfvuEwCAl2bVl0byT_ZLPE0Tz1yUQKMGdAmPkQ",

  apiUrl: 'https://mobil.itmc.tu-dortmund.de',
  katalogPlusUrl: 'https://katalog.ub.tu-dortmund.de/search?q=',

  oidc: {
    useDevelopmentAccessToken: false,
    issuer: 'https://sso.itmc.tu-dortmund.de/openam/oauth2/realms/tudo',
    clientId: 'mobile-app-oidc-v2p',
    redirectUri: 'https://tu-dortmund.de/app/login',
    pwaRedirectUri: 'https://app.itmc.tu-dortmund.de',
    scope: 'offline_access openid profile eduperson tudo-org tudo-stud memberof',
    expiryBufferSeconds: 30,
  },

  tiles: [
    { id: 'news' },
    { id: 'canteen' },
    { id: 'events' },
    { id: 'lsf' },
    { id: 'employee-search' },
    { id: 'campus-navi' },
    { id: 'study-areas'},
    { id: 'departure-monitor' },
    { id: 'hochschulsport', url: 'https://www.buchsys.ahs.tu-dortmund.de/sportarten/aktueller_zeitraum/m.html' },
    { id: 'asta', url: 'https://service.asta-dortmund.de/app' },
    { id: 'ufc', url: 'https://ufc.tu-dortmund.de' },
    { id: 'feedback' },
    { id: 'emergency' },
    { id: 'campus-id/employee', iconName: 'campus-id-e', titleKey: 'campus-id.employee.title', access_roles: ['employee'] },
    { id: 'campus-id/student', iconName: 'campus-id-s', titleKey: 'campus-id.student.title', access_roles: ['student'] },
    { id: 'timetable', access_roles: ['student'] },
    { id: 'ticket', access_roles: ['student'] },
    { id: 'exams', access_roles: ['student'] },

    { id: 'ub-account', access_roles: ['student', 'employee', 'extusers@library.tu-dortmund.de'] },
    { id: 'vscout', access_roles: ['student', 'employee', 'extusers@library.tu-dortmund.de'], url: 'https://scout-efb.ub.tu-dortmund.de' },
    { id: 'katalog-plus', url: 'https://katalog.ub.tu-dortmund.de', titleKey: 'ub.katalogPlus' },

    { id: 'canteen-coupon', access_roles: ['AZUBI'] },
    { id: 'employee-profile', access_roles: ['employee'], modal: true },
    { id: 'wlan-password', access_roles: ['member'] },
    { id: 'health-passport', access_roles: ['employee'], titleKey: 'healthPassport.title' },
    { id: 'damage-report', access_roles: ['employee'] },
  ]
};
